import type { IDirective } from "angular";
import { module } from "angular";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputPhoneDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        irLabel: "<",
        ngModel: "=",
    };

    public template: string;

    public link = InputDirectiveFunctions.link; // eslint-disable-line @typescript-eslint/unbound-method

    public compile = InputDirectiveFunctions.compile(this.link);

    constructor() {
        this.template = `<input type="tel" aa-field-group="ngModel" aa-label="{{irLabel | translate}}"
            ng-pattern="$root.validation.phoneNumberPattern"
            ng-pattern-msg="{{'Validation.IsNotValidPhoneNumber' | translate : {propertyName: '{0}'} }}">`;
    }
}

module("mmGui").directive("irInputPhone", () => new InputPhoneDirective());
